import {Link, useLocation} from "react-router-dom";
import {Paths} from "../../paths";

import {FaBuildingColumns, FaBuildingUser, FaTags} from "react-icons/fa6";


export const UserNav = () => {

    const {pathname} = useLocation();

    return (
        <div className="main-nav scrollarea">
            <div className="d-flex flex-between-center mb-2 p-3 pb-0"><p
                className="text-uppercase fs-10 text-body-tertiary text-opacity-85 mb-0 fw-bold">Основные разделы</p>
            </div>
            <Link to={Paths.user_categories}
                  className={`main-nav-link ${pathname.includes("/user/categories") ? "active" : ""}`}>
                <FaTags size={18}/>
                <span className={"flex-text"}>Категории</span>
            </Link>
            <Link to={Paths.user_objects}
                  className={`main-nav-link ${pathname.includes("/user/objects") ? "active" : ""}`}>
                <FaBuildingColumns size={18}/>
                <span className={"flex-text"}>Объекты</span>
            </Link>
            <Link to={Paths.user_object_ankets}
                  className={`main-nav-link ${pathname.includes("/user/object_ankets") ? "active" : ""}`}>
                <FaBuildingUser size={18}/>
                <span className={"flex-text"}>Анкеты объектов</span>
            </Link>
        </div>
    );
};

export default UserNav;